// @flow
import { PrioridadesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    // prioridad: {},
    listaPrioridades: [],
    loading: false,
    error: false,
    // formSubmited:false
};

type PrioridadesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { prioridad?: {} | null, listaPrioridades?: [] | null, loading?: boolean, +value ?: boolean };

const Prioridades = (state: State = INIT_STATE, action: PrioridadesAction): any => {
    // console.prioridad(action);
    switch (action.type) {
        case PrioridadesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                // case PrioridadesActionTypes.GET_PRIORIDAD: {
                //     return {
                //         ...state,
                //         prioridad: action.payload.data,
                //         error:false,
                //         loading: false,
                //     };
                // }
                case PrioridadesActionTypes.LIST_PRIORIDADES: {
                    return {
                        ...state,
                        listaPrioridades: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                // case PrioridadesActionTypes.ADD_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error:false,
                //         loading: false,
                //         formSubmited:true
                //     };
                // }
                // case PrioridadesActionTypes.UPDATE_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error:false,
                //         loading: false,
                //         formSubmited:true
                //     };
                // }
                // case PrioridadesActionTypes.DELETE_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error:false,
                //         loading: false,
                //     };
                // }
                default:
                    return { ...state };
            }

        case PrioridadesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                // case PrioridadesActionTypes.GET_PRIORIDAD: {
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         prioridad:{},
                //         loading: false,
                //     };
                // }
                case PrioridadesActionTypes.LIST_PRIORIDADES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaPrioridades: [],
                        loading: false,
                    };
                }
                // case PrioridadesActionTypes.ADD_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //         formSubmited:true
                //     };
                // }
                // case PrioridadesActionTypes.UPDATE_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //         formSubmited:true
                //     };
                // }
                // case PrioridadesActionTypes.DELETE_PRIORIDAD:{
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         loading: false,
                //     };
                // }
                default:
                    return { ...state };
            }

        // case PrioridadesActionTypes.GET_PRIORIDAD:
        //     return { ...state,error:false, loading: true};
        case PrioridadesActionTypes.LIST_PRIORIDADES:
            return { ...state, error: false, loading: true };
        // case PrioridadesActionTypes.ADD_PRIORIDAD:
        //     return { ...state,error:false, loading: true };
        // case PrioridadesActionTypes.UPDATE_PRIORIDAD:
        //     return { ...state,error:false, loading: true };
        // case PrioridadesActionTypes.DELETE_PRIORIDAD:
        //     return { ...state,error:false, loading: true };
        case PrioridadesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                // prioridad:{},
                listaPrioridades: [],
                // formSubmited:false
            };
        default:
            return { ...state };
    }
};

export default Prioridades;
